import { FormElement } from '../../schema/form.schema';
import React from 'react';
import styles from '../../assets/css/tabs.module.css';
import FormElementComponent from '../form/FormElement';
import { FormDataValue } from '../../hooks/useFormData';

interface TabsProps {
	currentOption: string;
	handleChange: (value: string) => void;
	options: Array<{ value: string; label: string; content: Array<FormElement> }>;
	onChange: (key: string, value: FormDataValue) => void;
	onValidationChange: (key: string, value: boolean) => void;
}

const Tabs: React.FC<TabsProps> = ({ currentOption, handleChange, options, onChange, onValidationChange }) => {
	const tabContentStyle = {
		padding: currentOption === undefined ? '0px' : '10px'
	};

	return (
		<div className={styles['tabs']}>
			{options.map((option) => (
				<div
					key={option.value}
					className={currentOption === option.value ? styles.tab + ' ' + styles.active : styles.tab}
					onClick={() => handleChange(option.value)}
				>
					{option.label}
				</div>
			))}
			<div className={styles['tab-content']} style={{ ...tabContentStyle }}>
				{options
					.find((option) => option.value === currentOption)
					?.content.map((element, index) => (
						<div key={index}>
							<FormElementComponent
								element={element}
								onChange={onChange}
								onValidationChange={onValidationChange}
							/>
						</div>
					))}
			</div>
		</div>
	);
};

export default Tabs;
